// Fallback defaults for editable static pages (About, Home, Amenities, Contact).
// Kept in sync with backend/seed_pages.json. Used when the API is unreachable.
export const PAGE_DEFAULTS = {
  about: {
    heroImage: "/about-hero.jpg",
    tagline: "Our Story",
    heading: "Workspaces designed for the way you actually work.",
    intro:
      "Bond Collective began with a simple belief: the place you work should inspire you. We set out to build workspaces that feel less like an office and more like a beautifully designed home for ambitious people and the teams they're building.",
    paragraphs: [
      "From our first location to a portfolio spanning the East Coast to Texas and Florida, every Bond Collective space is thoughtfully curated, from the furniture and lighting to the art on the walls and the coffee in your cup.",
      "We pair striking, design-led interiors with genuine hospitality and the flexibility modern teams need. Whether you're a solo founder, a remote worker, or a growing company, there's a home for you here.",
    ],
    stats: [
      { value: "5", label: "Cities" },
      { value: "4", label: "States" },
      { value: "24/7", label: "Member Access" },
      { value: "100%", label: "Move-In Ready" },
    ],
    values: [
      { icon: "Sparkles", title: "Design-Led", desc: "Every detail is considered. We believe beautiful spaces make for better work." },
      { icon: "HeartHandshake", title: "Hospitality-First", desc: "Our teams treat members like guests, with service that's personal and proactive." },
      { icon: "Users", title: "Community", desc: "Curated events and shared spaces designed to spark real connection." },
      { icon: "Infinity", title: "Flexibility", desc: "Month-to-month terms and spaces that scale as your needs change." },
    ],
    quote:
      "We're not just renting space — we're creating environments where people genuinely love to spend their days.",
  },
  home: {
    heroKicker: "Boutique Coworking & Private Offices",
    heroTitle: "Workspaces designed for the way you actually work.",
    heroSubtitle:
      "From private offices to flexible coworking, thoughtfully designed spaces with business-class amenities and genuine hospitality.",
    solutionsKicker: "Workspace Solutions",
    solutionsHeading: "Find the space that fits.",
    featureKicker: "Designed for Focus",
    featureHeading: "Every detail considered, so you can do your best work.",
    featureBody:
      "24-hour access to all locations, custom build-outs, and business-class services with a personal touch, plus thoughtfully designed interiors that make you want to show up.",
    featureImage: "/home/designed-focus.jpg",
    amenitiesKicker: "All This & More",
    amenitiesHeading: "Amenities included",
    ctaHeading: "Ready to find your space?",
    ctaSubtitle: "Book a private tour and experience a Bond Collective workspace firsthand.",
  },
  amenities: {
    heroImage: "/amenities-hero.jpg",
    heroKicker: "All This & More",
    heroTitle: "Amenities",
    heroSubtitle: "Everything that makes your workday smoother, included with every membership.",
    introKicker: "Thoughtfully Equipped",
    introHeading: "Everything you need, nothing you don't.",
    introBody:
      "24-hour access, custom build-outs, and a long list of perks designed to make your workday smoother and your guests impressed.",
    introImage1: "/amenity-1.jpg",
    introImage2: "/amenity-2.jpg",
    list: [
      "Conference Rooms for 2 or 20+",
      "Custom Build-Outs",
      "Private Meeting & Phone Booths",
      "Guest Reception & Greeting",
      "Expertly Designed Interiors",
      "Mail and Package Handling",
      "Fast, Reliable WiFi and Ethernet",
      "Unlimited Black & White Printing",
      "Daily Porter & Nightly Cleanings",
      "Handymen & Installations Available",
      "Amenitized Showers with Towel Service",
      "Fresh Fruit, Snacks & Weekly Breakfast",
      "Complimentary Spa Water, Craft Beer & Coffee",
      "Mothers' Room",
      "Secure Bike Storage",
      "Curated Networking Events",
      "Exclusive Discounts & National Partnerships",
      "Pet-friendly Locations & Common Areas",
      "Access to Other Portfolio Locations",
      "Streamlined Billing & Booking Portal",
    ],
    ctaImage: "/memberships/coworking.jpg",
    ctaHeading: "See it all in person.",
  },
  contact: {
    kicker: "Get in Touch",
    heading: "Contact Us",
    subtitle: "Questions about memberships, events, or partnerships? We'd love to hear from you.",
    email: "hello@bondcollective.com",
    phone: "(929) 588-8294",
  },
};
